<template>
  <h2 class="form-section-title">{{ props.formElement.properties?.sectionTitle }}</h2>
</template>

<script lang="ts" setup>
import type { FormSectionTitleElement } from "../types";

interface IProps {
  formElement: FormSectionTitleElement;
}

const props = defineProps<IProps>();
</script>
